import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';

type PermissionsCheckerModel = ModuleBaseModel<
  {
    requiredFlags: number;
  } & ModuleBasePropsModel
>;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PermissionsChecker = (data: PermissionsCheckerModel) => {
  return null;
};

export default PermissionsChecker;
